// Times the lookup asks for: typed in the viewer's time zone, sent as UTC.

/** A `datetime-local` value for a moment, in the viewer's time zone. */
export function toLocalInput(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${String(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** A `datetime-local` value, read in the viewer's time zone, as UTC RFC 3339; null if it isn't a time. */
export function localInputToUtc(value: string): string | null {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}
